import React from "react";
import "./footer/Footer.css";

const AboutUs = () => {
  return (
    <div className="extra">
      <h3>About Us</h3>
      <h4>
        Welcome to FerryWave - the easiest way to book ferry trips in Scotland!
        Our team of students created this online platform to simplify the
        process of exploring Scotland's islands. With a clean and modern design
        that is easy to use on any device, we offer a comprehensive guide to
        finding the most convenient and affordable ferry services in Scotland.
        Whether you're a local or a tourist, FerryWave has got you covered!{" "}
      </h4>
    </div>
  );
};

export default AboutUs;
